import {
  AbstractControl,
  FormControl,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import * as moment from "moment";
import { cleanCharactersInString } from "./helpers/functions";
import { localDB } from "src/app/shared/helpers/localStorage";

export class GenericValidators {

  // validación de horario colaborador para registro de tareo
  static isIntoSchedule(validators: any): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      let res = null;

      if (!(control.value != null && control.value.toString().trim() != "" && control.parent && control.value.includes(':'))) {
        return null;
      }

      const parent = control.parent;
      const dHora_Inicio = parent.get('dHora_Inicio')?.value;
      const Fecha_Inicio = parent.get('dFecha_Inicio')?.value;
      const dFecha_Inicio = `${moment(Fecha_Inicio).format('YYYY-MM-DD')} ${dHora_Inicio}`;
      const nMins = parent.get('nMinutos')?.value;
      const dFecha_Fin = moment(dFecha_Inicio).add(nMins, 'minutes').format('YYYY-MM-DD HH:mm:ss');

      const fechaRegistro = parent.get("dFecha_Registro")?.value;
      if (!fechaRegistro) return null;

      const findByDate = (date: string) => validators.find((x: any) => x.dDate == date);

      const validator = findByDate(fechaRegistro);
      if (!validator) return null;

      let validatorNext = findByDate(moment(fechaRegistro).add(1, "days").format("YYYY-MM-DD"));
      const validatorPrevious = findByDate(moment(fechaRegistro).subtract(1, "days").format("YYYY-MM-DD"));

      const buildNextIfMissing = (base: any) => {
        const ddate = moment(base.dDate).add(1, "days").format("YYYY-MM-DD");
        const schedulejson = localDB.getItem('schedule');
        const schedule = schedulejson ? JSON.parse(schedulejson) : [];
        const isTomorrowHoliday = JSON.parse(localDB.getItem("holidays") || "[]").find((x: any) => x.sDescripcion === ddate);
        const dias_laborales = new Set(schedule.map((x: any) => x.nDia));
        let nDia = moment(ddate).day();
        nDia = nDia || 7;

        const statusTask = (!dias_laborales.has(nDia) || isTomorrowHoliday) ? 'FUERA_HORARIO_REGULAR' : 'HORARIO_REGULAR';
        let startMark = '00:00:00';
        let endMark = '00:00:00';

        if (dias_laborales.has(nDia)) {
          const scheduleByDay = schedule.find((x: any) => x.nDia === nDia);
          if (scheduleByDay?.Intervals) {
            const maxInterval = Math.max(...Object.keys(scheduleByDay.Intervals).map(Number));
            const startInterval = scheduleByDay.Intervals['1']?.find((x: any) => x.nType_Mark === 1);
            const endInterval = scheduleByDay.Intervals[String(maxInterval)]?.find((x: any) => x.nType_Mark === 2);
            startMark = startInterval ? startInterval.dHour : startMark;
            endMark = endInterval ? endInterval.dHour : endMark;
          }
        }

        return {
          ...base,
          dDate: ddate,
          sEstado_Horario: statusTask,
          entrada: startMark,
          salida: endMark,
        };
      };

      if (!validatorNext) {
        validatorNext = buildNextIfMissing(validator);
      }

      const start = moment(`${validator.dDate} ${validator.entrada}`);
      const end = moment(`${validator.dDate} ${validator.salida}`);
      const inicio = moment(dFecha_Inicio);
      const fin = moment(dFecha_Fin);
      const seSolapan = inicio.isBefore(end) && fin.isAfter(start);

      const isRegularOrSolicitud = (v: any) =>
        v && ['HORARIO_REGULAR', 'SOLICITUD_POR_HORA'].includes(v.sEstado_Horario);

      if (isRegularOrSolicitud(validator) && seSolapan) {
        res = { isIntoSchedule: true };
        return res;
      }

      if (
        isRegularOrSolicitud(validatorNext) &&
        moment(dFecha_Fin).isSameOrAfter(moment(`${validatorNext.dDate} ${validatorNext.entrada}`))
      ) {
        res = { isIntoSchedule: true };
        return res;
      }

      if (
        validatorPrevious &&
        isRegularOrSolicitud(validatorPrevious) &&
        (
          moment(dFecha_Fin).isSameOrBefore(moment(`${validatorPrevious.dDate} ${validatorPrevious.salida}`)) ||
          moment(dFecha_Inicio).isSameOrBefore(moment(`${validatorPrevious.dDate} ${validatorPrevious.entrada}`))
        )
      ) {
        res = { isIntoSchedule: true };
        return res;
      }

      return res;
    };
  }


  /* Validar que todos los caracteres sean solo números o caracteres de alfabeto */
  static alphanumeric(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/^[0-9a-zA-Z]+$/.test(control.value)) return null;
      else return { alphanumeric: true };
    } else {
      return null;
    }
  }

  /* Validar que contenga al menos una numero */
  static hasNumber(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/\d/.test(control.value)) return null;
      else return { hasNumber: true };
    } else {
      return null;
    }
  }

  /* Validar que contenga al menos una letra mayuscula */
  static hasCapitalCase(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/[A-Z]/.test(control.value)) return null;
      else return { hasCapitalCase: true };
    } else {
      return null;
    }
  }

  /* Validar que contenga al menos una letra miniscula */
  static hasSmallCase(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/[a-z]/.test(control.value)) return null;
      else return { hasSmallCase: true };
    } else {
      return null;
    }
  }

  /* Validar que contenga al menos un caracter especial */
  static hasSpecialCharacters(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(control.value))
        return null;
      else return { hasSpecialCharacters: true };
    } else {
      return null;
    }
  }

  /* Validar que todos los caracteres sean solo números o caracteres de alfabeto */
  static document(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/^[a-zA-Z0-9]{7,12}$/.test(control.value)) return null;
      else return { document: true };
    } else {
      return null;
    }
  }

  /* Validar que todos los caracteres sean solo números o caracteres de alfabeto */
  static numeric(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/^[0-9.]+$/.test(control.value)) return null;
      else return { numeric: true };
    } else {
      return null;
    }
  }

  /* Validar que todos los caracteres sean solo números o caracteres de alfabeto */
  static numericDecimal(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/^\d*\.?\d{1,2}$/.test(control.value)) return null;
      else return { numericDecimal: true };
    } else {
      return null;
    }
  }

  /* Validar que todos los caracteres sean solo números o caracteres de alfabeto */
  static numericMoneyDecimal(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      let cleanValue: string = cleanCharactersInString(control.value);

      let isInteger: RegExp = /^\d+$/;
      let isNumberWithMilesSeparator: RegExp = /^\d{1,3}\.\d{3},\d{2}$/;
      let isNmberWithoutMilesSeparator: RegExp = /^\d{1,8},\d{2}$/;

      if (
        isNumberWithMilesSeparator.test(cleanValue) ||
        isNmberWithoutMilesSeparator.test(cleanValue) ||
        isInteger.test(cleanValue)) return null;

      return { numericMoneyDecimal: true };
    } else {
      return null;
    }
  }

  static onlyNumbersGreatersOrEqualMoney(numberGreater: number): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      if (control.value != null && control.value.toString().trim() != "") {
        let cleanValue: string = cleanCharactersInString(control.value);
        let valor: string = cleanValue.replaceAll(".", "").replaceAll(",", ".");

        if (Number(valor) >= numberGreater) return null;
        else return { IsNotNumberGreaterOrEqualMoney: true };
      } else {
        return null;
      }
    };
  }

  /* Valida un email */
  static emailValidation(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (
        /^[^@]+@[^@]+\.[a-zA-Z]{2,4}$/.test(
          control.value
        )
      )
        return null;
      else return { emailValidation: true };
    } else {
      return null;
    }
  }

  /* Valida un email del dominio materiagris.pe */
  static emailMateriaGrisValidation(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/^[a-z.]+@materiagris\.pe$/.test(control.value)) return null;
      else return { emailMateriaGrisValidation: true };
    } else {
      return null;
    }
  }

  /* Validar que todos los caracteres sean solo números */
  static onlyNumberValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/^\d+$/.test(control.value)) return null;
      else return { IsNotNumber: true };
    } else {
      return null;
    }
  }

  /*Validar que lo caracteres sean solo alfanumericos*/
  static onlyAlphaNumberValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/^[a-zA-Z0-9]*$/.test(control.value)) return null;
      else return { onlyAlphaNumber: true };
    } else {
      return null;
    }
  }

  /* Validar que todos los caracteres sean solo números mayores a 0 */
  static onlyNumbersGreaterZero(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/^\d+$/.test(control.value) && control.value > 0) return null;
      else return { IsNotNumberGreaterZero: true };
    } else {
      return null;
    }
  }

  /* Validar que todos los caracteres sean caracteres de alfabeto y espacios */
  static onlyTextOrSpaceValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/^[A-ZÁÉÍÓÚÄËÏÖÜÑa-záéíóúäëïöüñ ]+$/.test(control.value)) return null;
      else return { IsNotTextOrSpace: true };
    } else {
      return null;
    }
  }

  /* Validar que no dos contraseñas coincidan */
  static passwordMatch(
    controlPassword: AbstractControl,
    controlConfirmPassword: AbstractControl
  ) {
    if (
      controlPassword.value != null &&
      controlPassword.value.toString().trim() != "" &&
      controlConfirmPassword.value != null &&
      controlConfirmPassword.value.toString().trim() != ""
    ) {
      if (controlPassword.value == controlConfirmPassword.value) { controlConfirmPassword.setErrors(null); }
      else { controlConfirmPassword.setErrors({ NoPasswordMatch: true }); }
    }
  }

  /* Validar el tipo de archivo */
  static validateAllowedFileType(arrayTypes: any[]): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      if (control.value) {
        let uploadFileIsAllowed = arrayTypes.includes(control.value.type);
        if (!uploadFileIsAllowed) {
          return { validate_file_type: true };
        }
      }
      return null;
    };
  }

  /* Validar el tamaño del archivo */
  static validateSizeFile(sizeMaxKB: number): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      if (control.value) {
        let fileSize = Number.parseInt(control.value.size);
        let fileSizeMb = fileSize / 1024;
        if (fileSizeMb > sizeMaxKB) {
          return { validate_file_size: true };
        }
      }
      return null;
    };
  }

  // Validar la cantidad de caractares mínimas
  static validateMinLength(number: number): ValidatorFn {
    return function (control: AbstractControl): {
      [key: string]: boolean
    } | null {
      if (control.value) {
        let str = control.value.toString();
        if (str.length < Number.parseInt(String(number)))
          return { validate_min_length: true };
      }
      return null;
    }
  }

  // Validar la cantidad de caractares máxima
  static validateMaxLength(number: number): ValidatorFn {
    return function (control: AbstractControl): {
      [key: string]: boolean
    } | null {
      if (control.value) {
        let str = control.value.toString();
        if (str.length > Number.parseInt(String(number)))
          return { validate_max_length: true };
      }
      return null;
    }
  }

  static forcedMinTime(forcedMinTime: number): ValidatorFn {
    return function (control: AbstractControl): {
      [key: string]: boolean
    } | null {
      if (forcedMinTime > 0) {
        return { wrong_time: true };
      }
      return null;
    }
  }

  /* Validar que el numero sea mayor a un número específico */
  static onlyNumbersGreatersOrEqual(numberGreater: number): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      if (control.value != null && control.value.toString().trim() != "") {
        if (Number(control.value) >= numberGreater) return null;
        else return { IsNotNumberGreaterOrEqual: true };
      } else {
        return null;
      }
    };
  }

  /* Validar que el numero sea menor a un número específico */
  static onlyNumbersLessOrEqual(numberLess: number): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      if (control.value != null && control.value.toString().trim() != "") {
        if (Number(control.value) <= numberLess) return null;
        else return { IsNotNumberLessOrEqual: true };
      } else {
        return null;
      }
    };
  }
  // Validar espacios en blancos
  static notOnlyWhitespaceValidator(control: FormControl) {
    const value = control.value;
    const isWhitespace = (value ?? "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  static stringWithNoSpaces(control: FormControl): { [key: string]: boolean } | null {
    const minSpaces: number = 5;
    const spaceAtTheBeginning: boolean = new RegExp(`^ {${minSpaces},}`).test(control.value);
    const spacesAtTheEnd: boolean = new RegExp(` {${minSpaces},}$`).test(control.value);

    return (spaceAtTheBeginning || spacesAtTheEnd) ? { withUnnecessarySpaces: true } : null;
  }

  static onlyAdmittedCharacters(validCharactersRegex: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.toString().trim();
      if (!value) return null;
      return validCharactersRegex.test(value) ? null : { onlyAdmittedCharacters: true };
    };
  }

  /* Validar horas fuera del horario laboral */
  /* Validar horas fuera del horario laboral */
  static isOutSchedule(schedule: any): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      if (!control.value) return null;
      let controlValue = moment(
        schedule.fecha.format("YYYY-MM-DD") + "T" + control.value,
        "YYYY-MM-DDTHH:mm"
      );
      let entrada = moment(schedule.entrada.format("YYYY-MM-DDTHH:mm"), "YYYY-MM-DDTHH:mm");
      let salida = moment(schedule.salida.format("YYYY-MM-DDTHH:mm"), "YYYY-MM-DDTHH:mm");
      if (schedule.dosDias) {
        let controlValueSplit = Number.parseInt(control.value.split(":").join(""));
        let out = Number.parseInt(salida.format("HH:mm").split(":").join(""));
        if (controlValueSplit >= 0 && controlValueSplit <= out) {
          controlValue = controlValue.add(1, "day");
        }
      }
      if (controlValue.isBefore(entrada)) {
        return { isOutSchedule: true };
      }
      if (controlValue.isSameOrAfter(salida)) {
        return { isOutSchedule: true };
      }
      return null;
    };
  }
  /* Validar que la hora no este dentro de un rango */
  static isIntoHourRange(rangeHours: any): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      if (!control.value || !rangeHours.length) return null;
      for (const hour of rangeHours) {
        let controlValue = moment(
          hour.fecha.format("YYYY-MM-DD") + "T" + control.value,
          "YYYY-MM-DDTHH:mm"
        );
        let inicio = moment(hour.inicio.format("YYYY-MM-DDTHH:mm"), "YYYY-MM-DDTHH:mm");
        let fin = moment(hour.fin.format("YYYY-MM-DDTHH:mm"), "YYYY-MM-DDTHH:mm");
        if (hour.dosDias) {
          let controlValueSplit = Number.parseInt(control.value.split(":").join(""));
          let out = Number.parseInt(fin.format("HH:mm").split(":").join(""));
          if (controlValueSplit >= 0 && controlValueSplit <= out) {
            controlValue = controlValue.add(1, "day");
          }
        }
        if (
          controlValue.isSameOrAfter(inicio) &&
          controlValue.isBefore(fin)
        ) {
          return { isIntoHourRange: true };
        }
      }
      return null;
    };
  }

  /* Validar que la hora sea mayor a la hora + cantidad de minutos */
  static minimumHour(
    cantMin: number,
    dateParent: AbstractControl | null
  ): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      let return0 = null;
      if (control.value && dateParent!.value) {
        let date = dateParent!.value.format('YYYY-MM-DD');
        let controlValue = moment(
          date + ' ' + control.value,
          'YYYY-MM-DD HH:mm'
        );
        let start = moment().add(cantMin, 'minutes');
        if (controlValue.isBefore(start)) {
          return0 = { minimumHour: true };
        }
      }
      return return0;
    };
  }

  /* Validar que la opcion elegida exista en el array de opciones */
  static optionExistInArray(aOptions: any[]): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      if (control.value != null && control.value.toString().trim() != "") {
        if (aOptions.includes(control.value)) return null;
        else return { optionInvalid: true };
      } else {
        return null;
      }
    };
  }

  /* Validar que un array no este vacio */
  static emptyArrayOptions(arrayOptions: any[]): ValidatorFn {
    return function (
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      if (arrayOptions.length) {
        return null;
      } else {
        return { isEmptyArrayOptions: true };
      }
    };
  }

  /* Validar que todos los caracteres sean solo números o caracteres de alfabeto */
  static defaultDescription(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value != null && control.value.toString().trim() != "") {
      if (/^[0-9 a-zA-Z.ÑñÁÉÍÓÚáéíóúÄËÏÖÜäëïöü]+$/.test(control.value))
        return null;
      else return { defaultDescription: true };
    } else {
      return null;
    }
  }
}
